export const positionListings = {
  header: 'Post A Job',
  subHeader: 'Select a position to create a new job posting',
  otherOptions: 'Other posting options',
  filters: {
    venue: {
      label: 'Location'
    },
    position: {
      label: 'Job position',
      placeholder: 'Search'
    },
    owner: {
      label: 'Owner'
    },
    classification: {
      label: 'Class',
      all: 'All',
      c1099: '1099',
      w2: 'W2'
    },
    schedule: {
      label: 'Schedules',
      all: 'All',
      preset: 'Preset',
      none: 'No schedule attached'
    }
  },
  table: {
    pay: {
      hourly: '%hourlyRate% Hourly',
      flat: '%flatRate% Flat'
    },
    shift: {
      break: '%breakMinutes% min break',
      customHours: 'Custom Hours'
    },
    actions: {
      create: 'Create'
    }
  },
  dressCodeModal: {
    header: 'Do you want to update this position?',
    description: 'This position is missing clothing requirements, which helps workers show up to the job prepared.',
    position: {
      header: 'Position'
    },
    hasDressCodeRequirements: {
      header: 'Clothing Requirements',
      prompt: 'Do you have any clothing requirements for this position?',
      no: "No, I don't have a preference"
    },
    cancel: 'No, update later',
    submit: 'Continue'
  },
  empty: {
    header: 'No Job Positions',
    subheader: 'Try different keywords or revising filters'
  }
};
